import { render } from "./LoginCreate.vue?vue&type=template&id=1d7b710a"
import script from "./LoginCreate.vue?vue&type=script&lang=js"
export * from "./LoginCreate.vue?vue&type=script&lang=js"
script.render = render

export default script